<template>
  <Modal ref="modal" v-bind="{ redirectOnClose: true }">
    <div class="modal max-w-md mx-auto" slot-scope="{ closeModal }" @click.stop>
      <div class="modal__header">
        <h6 class="heading capitalize">New Package Edition</h6>
      </div>
      <div class="modal__body space-y-4">
        <ValidationObserver slim v-slot="{ handleSubmit, invalid }" ref="observer">
          <form class="space-y-16" @submit.prevent="handleSubmit(submitForm)">
            <div class="space-y-8">
              <ValidationProvider
                name="name"
                vid="name"
                rules="required"
                v-slot="{ errors, failed }"
                slim
              >
                <BaseFormGroup class="w-full">
                  <BaseFormLabel for="name"> Name * </BaseFormLabel>
                  <BaseFormInput
                    id="name"
                    v-model="wipName"
                    :disabled="submitting"
                    :invalid="failed"
                    placeholder="enter name..."
                    v-select
                  />
                  <BaseFormInlineMessage v-if="failed" danger>
                    {{ errors[0] }}
                  </BaseFormInlineMessage>
                </BaseFormGroup>
              </ValidationProvider>
            </div>
            <div class="space-x-2 text-right">
              <BaseButton type="button" ghost :disabled="submitting" @click="closeModal">
                Cancel
              </BaseButton>
              <BaseButton type="submit" primary :disabled="invalid || submitting">
                Submit
              </BaseButton>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from '@/components/Ui/Modal.vue';

export default {
  name: 'ModalCreate',
  components: {
    Modal,
  },
  props: {
    wip: {
      type: Object,
      required: true,
    },
    submitting: Boolean,
  },
  computed: {
    wipName: {
      get() {
        return this.wip.name;
      },
      set(name) {
        this.$emit('form-data-changed', { name });
      },
    },
  },
  methods: {
    submitForm() {
      const next = this.$refs.modal.closeModal;
      this.$emit('form-data-submit', next);
    },
  },
};
</script>
